import { render, staticRenderFns } from "./ShipmentInfoPopup.vue?vue&type=template&id=3416bc2c"
import script from "./ShipmentInfoPopup.vue?vue&type=script&lang=js"
export * from "./ShipmentInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./ShipmentInfoPopup.vue?vue&type=style&index=0&id=3416bc2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports